import { AfterViewChecked, AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Store } from "@ngrx/store";
import { isInternalTransferForm, ItExtraPrompts, ItTransactionDetails, TransactionForm } from "projects/money-movement-ui/src/app/create-request/models/form/TransactionForm";
import { selectCostBasisMethod, selectInternalTransferInfo, selectMultipleToJournalsList, selectStagedCostBasisMethod, selectStagedTransactionForm, selectIraFieldsIsIraTransaction, selectTransferType, selectTwe, selectToAccountPtrs, selectMultipleToAccountsPositionLotTableData, selectFrequency, selectStagedTransactionFormItExtraPrompts, selectTransactionFormExtraPrompts, selectToAccountsInfo, selectTwePopupIndicator } from "projects/money-movement-ui/src/app/create-request/reducers";
import { Subject, combineLatest, takeUntil, withLatestFrom } from "rxjs";
import { Constants, positionConstants, transactionDetailLabels, transferTypes, pageInContext, frequencyDict, RegTypeCode } from "../../../utilities/Constants";
import { InternalTransferInfo } from "projects/money-movement-ui/src/app/create-request/models/internal-transfer/InternalTransferInfo";
import { Classifications } from 'projects/money-movement-ui/src/app/account-info-header/models';
import { selectClassifications, selectNraIndicator, selectStateCode } from 'projects/money-movement-ui/src/app/account-info-header/reducers';
import { AccountInfoActions } from 'projects/money-movement-ui/src/app/account-info-header/actions';
import { IraFields } from 'projects/money-movement-ui/src/app/create-request/models/ach/IraFields';
import { selectInternalTransfersInfo } from 'projects/money-movement-ui/src/app/create-request/reducers';
import { InternalTransfersInfo } from 'projects/money-movement-ui/src/app/create-request/models/internal-transfer/InternalTransfersInfo';
import { CurrencyPipe } from '@angular/common';
import { currencyStringToNumber } from "projects/money-movement-ui/src/app/create-request/utilities/currencyStringToNumber";
import { CamelCasePipe } from "../../../pipes/CamelCasePipe";
import { TableColumn } from "../../../types/TableColumn";
import { selectViewInContext } from "../../../reducers";
import { selectIsStandingAuthViewPage } from "projects/money-movement-ui/src/app/transaction-view/reducers";
import { ReviewPageActions } from "../../../../create-request/actions";
import { AdobeConstants } from "../../../adobe-tagging/AdobeConstants";
import { AdobeHelpers } from "../../../adobe-tagging/adobeHelper";
import { RemoveHyphenFromAccountPipe } from "../../../pipes/remove-hyphen-from-account.pipe";
import { FeatureFlagService } from "../../../services/feature-flag-service";
import { selectHasAccessInitiateMoneyMovement } from "projects/money-movement-ui/src/app/authorize/reducers";
import { FormatPercentPipe } from "../../../pipes/FormatPercentPipe";
import { Acknowledgement } from "projects/money-movement-ui/src/app/create-request/models/review-page/ReviewPage";
import { FormatDatePipe } from "../../../pipes/FormatDatePipe";


@Component({
  standalone: false,
    selector: 'mm-multiple-transaction-details-section-it',
    templateUrl: './multiple-transaction-details-section-it.component.html',
    styleUrls: ['./multiple-transaction-details-section-it.component.scss']
})

export class MultipleTransactionDetailsSectionItComponent implements OnInit, OnChanges, AfterViewInit  {
    @Input() toAccountInContextDetails: {toAccountNumber: string, toAccountName: string, toAccountType: string };
    @Input() transactionDetailsInContext: {contributionType: string, distributionReason: string};
    @Input() toAccountPTRSInfoInContext: {trustIncomeToPercent: string, trustPrincipalToPercent: string, trustDepositCode: string};
    @Input() displayToAccPTRSFields: boolean;
    @Input() confirmationPagePhase2: boolean = false;
    @Input() isCashAvailableInContext: boolean;
    @Input() zeroFedAndStateTax: boolean;
    @Input() fedTaxPercent: string;
    @Input() isInrFromTable: boolean;
    hyphenPipe = new RemoveHyphenFromAccountPipe();
    processDate: string;
    currentPage: string;
    camelCasePipe = new CamelCasePipe;
    readonly labels = transactionDetailLabels;
    readonly nextBusinessDayCopy: string = Constants.nextBusinessDayCopy;
    readonly reportsRequestedTooltipMsg: string = Constants.reportsRequestedTooltip;
    destroy$: Subject<boolean> = new Subject<boolean>();
    classifications: Classifications = new Classifications();
    transactionTypeLabel: string;
    transferType: string;
    formTransferType: string;
    costBasis: any | string = "";
    itInfo: InternalTransferInfo;
    trustIncomePercent: string;
    trustPrincipalPercent: string;
    trustTaxCategory: string;
    trustTaxCode: string;
    trustPaidFor: string;
    trustComment: string;
    fedTaxAmount: string;
    index: number;
    stateTaxAmount: string;
    iraFeilds: IraFields;
    distributionReasonCode: string;
    distributionReasonDescription: string;
    distributionReason: string[] = [];
    distributionReasonSubCode: string;
    isIraTransaction: boolean;
    itsInfo: InternalTransfersInfo;
    showToAccountPtrsFields: boolean = false;
    transferTotal: {receivingAccount: {accountNumber: string, accountName: string, accountType: string}, positionTotatValue: string, cashTotalValue: string}[] = [];
    showTransferTotalsCash: boolean = true;
    transactionDetailsInfo: {receivingAccount: {accountNumber: string, accountName: string, accountType: string}, contributionType: string, distributionReason: string, ptrsIncome: string, ptrsPrincipal: string,  ptrsDepositTaxCode: string}[] = [];
    transactionDetailsInfoTotalDist: {receivingAccount: {accountNumber: string, accountName: string, accountType: string }, contributionType?: string, distributionReason?: string, ptrsIncome?: string, ptrsPrincipal?: string,  ptrsDepositTaxCode?: string } = {receivingAccount: { accountNumber: '', accountName: '', accountType: '' }, contributionType: '', distributionReason: '', ptrsIncome: '', ptrsPrincipal: '', ptrsDepositTaxCode: ''};
    stagedTransactionDetailsInfo: TransactionForm;
    emvTotalDist: string | null;
    toAccountCashExists: boolean = false;
    iraToAccountExists: boolean = false;
    fedTax: string;
    stateTax: string;
    fedTaxTotalDist: string;
    stateTaxTotalDist: string;
    ToAccountTableWidth: string;
    TransferTableWidth: string;
    stateTaxLabel: string = this.labels.stateTax;
    positionData: TableColumn;
    isStandingAuthViewPage: boolean;
    isInitRelease: boolean;
    useStandingAuth: string = 'no';
    standingAuthDetails: string[] = [];
    isBundledStandingAuthTransaction: boolean;
    isOneTimeTotalDist: boolean = false;
    selectedFrequency: string;
    closeAccount: string;
    closeAccountFieldSelected: boolean = false;
    reportsRequested: string[] = [];
    is401kToAccount: boolean;
    has401kPtrsValuesSet: boolean = false;
    private twe: any;
    private openTwePopup: boolean = false;

    constructor(private store: Store, private currencyPipe: CurrencyPipe, private percentFormatPipe: FormatPercentPipe, private dateFormatPipe: FormatDatePipe) {}

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['fedTaxPercent'] || changes['zeroFedAndStateTax']) {
        this.updateTaxValues();
      }
    }

    ngOnInit(): void {
      this.store
        .select(selectIraFieldsIsIraTransaction)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (_isIraTransaction) => (this.isIraTransaction = _isIraTransaction)
        );
      this.store
        .select(selectInternalTransferInfo)
        .pipe(takeUntil(this.destroy$))
        .subscribe((itInfo) => {
          this.itInfo = itInfo;
        });

      this.store
        .select(selectClassifications)
        .pipe(takeUntil(this.destroy$))
        .subscribe((classifications) => {
          this.classifications = classifications;
          this.updateTaxValues();
        });

      this.store
        .select(selectFrequency)
        .pipe(takeUntil(this.destroy$))
        .subscribe((frequency) => {
          this.isOneTimeTotalDist = frequency === 'onetimeTotalDist';
        });
      this.store
        .select(selectInternalTransfersInfo)
        .pipe(takeUntil(this.destroy$))
        .subscribe((itsInfo) => {
          this.itsInfo = itsInfo;
          this.updateTaxValues();
          itsInfo.multipleToJournalsList.forEach((iraaccount) => {
            this.distributionReason.push(
              iraaccount.iraFields.distributionReason.code.trim() +
                '-' +
                iraaccount.iraFields.distributionReason.description.trim()
            );
          });
          Object.keys(itsInfo.toAccountInfo).forEach(toAccount => {
            this.transactionDetailsInfoTotalDist.receivingAccount.accountNumber = itsInfo.toAccountInfo[toAccount].accountNumber;
            this.transactionDetailsInfoTotalDist.receivingAccount.accountName = itsInfo.toAccountInfo[toAccount].accountRegistration[0];
            this.transactionDetailsInfoTotalDist.receivingAccount.accountType = itsInfo.toAccountInfo[toAccount].regTypeShortName;
            this.emvTotalDist = this.currencyPipe.transform(String(itsInfo?.rowData[toAccount]?.estimatedMarketValueTotal ?? 0));
          })
        });

      this.store
        .select(selectStagedTransactionForm)
        .pipe(takeUntil(this.destroy$))
        .subscribe((form) => {
          this.stagedTransactionDetailsInfo = form;
          if (form.transactionType && isInternalTransferForm(form)) {
            this.transactionTypeLabel = this.getTransactionTypeLabel(form.extraPrompts.useStandingAuth);
            let transactionDetails = form.transactionDetails;
            let extraPrompts = form.extraPrompts;
            this.selectedFrequency = this.getFrequency(extraPrompts);
            this.trustIncomePercent = this.classifications.isPtrs
              ? this.percentFormatPipe.transform(transactionDetails!.trustIncomePercent!)
              : '';
            this.trustPrincipalPercent = this.classifications.isPtrs
              ? this.percentFormatPipe.transform(transactionDetails!.trustPrincipalPercent!)
              : '';
            this.trustTaxCode = this.classifications.isPtrs
              ? transactionDetails!.trustTaxCode!
              : '';
            this.trustTaxCategory =
              form.transactionDetails.trustTaxCategory ?? '';
            this.trustPaidFor = this.classifications.isPtrs
              ? transactionDetails!.trustPaidFor!
              : '';
            this.trustComment = form.transactionDetails.trustComment ?? '';
            this.isBundledStandingAuthTransaction = form?.extraPrompts?.useBundledStandingAuth === 'yes';
            this.useStandingAuth = this.getStandingAuthDetails(form?.extraPrompts)
            this.closeAccount = form?.extraPrompts?.closeAccount ? form.extraPrompts.closeAccount.charAt(0).toUpperCase() + form.extraPrompts.closeAccount.slice(1) : '';
            if (currencyStringToNumber(transactionDetails?.cashAmounts?.[0]?.amount ?? '')) {
              this.toAccountCashExists = true;
            }
            if (transactionDetails?.toAccounts?.[0]?.iraContributionType) {
              this.iraToAccountExists = true;
            }
            this.transactionDetailsInfoTotalDist.distributionReason = transactionDetails?.toAccounts?.[0]?.iraDistributionType ? this.camelCasePipe.transform(transactionDetails?.toAccounts?.[0]?.iraDistributionType, true) : 'N/A';
            this.transactionDetailsInfoTotalDist.contributionType = transactionDetails?.toAccounts?.[0]?.iraContributionType ? transactionDetails?.toAccounts?.[0]?.iraContributionType : 'N/A';
            this.fedTaxTotalDist = (this.classifications.isNraAccount && this.transactionDetailsInfoTotalDist.distributionReason !== 'Combine-Accounts-(0-comb)' && this.transactionDetailsInfoTotalDist.distributionReason !== 'Qualified-(q)') ? '30%' : transactionDetails?.taxWithholdingsFormGroup?.fedTaxPercent ?? '';
            this.stateTaxTotalDist = transactionDetails?.taxWithholdingsFormGroup?.stateTaxPercent ?? '';
            this.syncHeaderTaxRates();
            this.getToAccountPTRSfieldsTotalDist(transactionDetails);
            this.formatReportsRequestedFields(form);
          }
        });

      this.store.select(selectViewInContext).pipe(takeUntil(this.destroy$)).subscribe(page => {
        this.currentPage = page;
        this.updateTaxValues();
      });

      this.store
        .select(selectTwe)
        .pipe(takeUntil(this.destroy$))
        .subscribe((twe) => {
              this.twe = twe;
              this.updateTaxValues();
        });

      this.store.select(selectToAccountsInfo).pipe(takeUntil(this.destroy$)).subscribe(toAccountInfo => {
        this.is401kToAccount = Object.values(toAccountInfo).some(info => (info?.registrationType === RegTypeCode.INDIVIDUAL_401K || info?.registrationType === RegTypeCode.ROTH_401K ));
      });

      combineLatest([
          this.store.select(selectTransferType),
          this.store.select(selectInternalTransferInfo),
        ]).pipe(takeUntil(this.destroy$)).subscribe(([transferType, itInfo]) => {
          this.transferType = (typeof transferType === 'string') ? transferType : "";
          if (this.transferType === transferTypes.POSITIONS) {
            if (itInfo.iraFields.isIraTransaction && (Number.parseFloat(itInfo.iraFields.fedTaxPercent) !== 0 || Number.parseFloat(itInfo.iraFields.stateTaxPercent) !== 0)) {
              this.formTransferType = this.labels.positionsCash;
            }
            else {
              this.formTransferType = this.labels.positions;
            }
            this.showTransferTotalsCash = false;
          }
          else if (this.transferType === transferTypes.CASH) {
            this.formTransferType = this.labels.cash;
          }
          else if (this.transferType === transferTypes.POSITIONS_CASH) {
            this.formTransferType = this.labels.positionsCash;
          }
          else {
            this.formTransferType = '';
          }
        });

      this.store.select(selectStagedTransactionFormItExtraPrompts).pipe(takeUntil(this.destroy$)).subscribe(extraPrompts => {
        if(extraPrompts?.taxForms || extraPrompts?.accountStatements || extraPrompts?.tradeConfirmations){
          this.closeAccountFieldSelected = true;
        }
      })

      combineLatest([
        this.store.select(selectStagedCostBasisMethod),
        this.store.select(selectCostBasisMethod),
      ])
      .pipe(takeUntil(this.destroy$)).subscribe(([costBasisMethod, defaultMethod]) => {
        if (defaultMethod === costBasisMethod) {
          this.costBasis = 'Account default: ' + this.getCBFormValue(defaultMethod);
        }
        else {
          this.costBasis = this.getCBFormValue(costBasisMethod ?? '')
        }
      })

      this.store.select(selectMultipleToJournalsList).pipe(
        takeUntil(this.destroy$),
        withLatestFrom(this.store.select(selectMultipleToAccountsPositionLotTableData),this.store.select(selectToAccountPtrs))
      ).subscribe(([VerifyResponseToAccountList,toPositionLotData, toAccountPtrsFields])=>{
        VerifyResponseToAccountList.forEach(toAccountResponse => {
          Object.keys(toPositionLotData).forEach((toAccount) => {
            this.positionData = toPositionLotData[toAccount].positionData;
            if(toAccount.replace(/-/g, '') == toAccountResponse.toAccountInfo.accountNumber.replace(/-/g, '')){
              if (currencyStringToNumber(toAccountResponse?.journalCashAmount)){
                this.toAccountCashExists = true;
              }
              this.transferTotal.push({
                receivingAccount: {
                  accountNumber: toAccountResponse.toAccountInfo.accountNumber,
                  accountName: toAccountResponse.toAccountInfo.accountRegistration[0] ?? '',
                  accountType: toAccountResponse.toAccountInfo.regTypeShortName ?? ''
                },
                positionTotatValue:this.calculateSelectedPositionTotal(),
                cashTotalValue: toAccountResponse.journalCashAmount
              });
              this.transactionDetailsInfo.push({
                receivingAccount: {
                  accountNumber: toAccountResponse.toAccountInfo.accountNumber,
                  accountName: toAccountResponse.toAccountInfo.accountRegistration[0] ?? '',
                  accountType: toAccountResponse.toAccountInfo.regTypeShortName ?? ''
                },
                contributionType: toAccountResponse?.iraContributionType?.description ? this.camelCasePipe.transform(toAccountResponse?.iraContributionType?.description, true) : 'N/A',
                distributionReason: toAccountResponse?.iraFields?.distributionReason?.description ? this.camelCasePipe.transform(toAccountResponse?.iraFields?.distributionReason?.description) : 'N/A',
                ...this.getToAccountPTRSfields(toAccountResponse, toAccountPtrsFields),
              });
              if (toAccountResponse?.toAccountInfo?.isIraAccount) {
                this.iraToAccountExists = true;
              }
            }
          })
          this.standingAuthDetails = [toAccountResponse?.toAccountInfo?.accountNumber + ' - ' + toAccountResponse?.toAccountInfo?.registrationType];
        })
        this.reorganizeToAccountOrder(this.transactionDetailsInfo);
        this.reorganizeToAccountOrder(this.transferTotal);

        if(this.is401kToAccount){
          Object.keys(toPositionLotData).forEach((toAccount) => {
            this.positionData = toPositionLotData[toAccount]?.positionData
            const toAccountInfo = this.itsInfo?.toAccountInfo[toAccount];

            // For 401k accounts, get PTRS data from toAccountPtrsFields
            const trustFields = this.itsInfo?.trustFields?.ptrs;
            const accountPtrsData = toAccountPtrsFields?.find((ptrsField: any) =>
              this.hyphenPipe.transform(ptrsField.toAccount) === this.hyphenPipe.transform(toAccount)
            );
              this.transferTotal.push({
                receivingAccount: {
                  accountNumber: toAccountInfo.accountNumber,
                  accountName: toAccountInfo.accountRegistration[0] ?? '',
                  accountType: toAccountInfo.regTypeShortName ?? ''
                },
                positionTotatValue:this.calculateSelectedPositionTotal(),
                cashTotalValue: this.itsInfo?.totalCashAmount
              });
              // Set PTRS values for 401k accounts
              const ptrsIncome = accountPtrsData?.trustIncomeToPercent || trustFields?.trustIncmPct || 'N/A';
              const ptrsPrincipal = accountPtrsData?.trustPrincipalToPercent || trustFields?.trustPrinPct || 'N/A';
              const ptrsDepositTaxCode = accountPtrsData?.trustDepositCode ? this.camelCasePipe.transform(accountPtrsData.trustDepositCode) : (trustFields?.trustTaxCode ? this.camelCasePipe.transform(trustFields.trustTaxCode) : 'N/A');

              // Update transactionDetailsInfoTotalDist
              this.transactionDetailsInfoTotalDist.ptrsIncome = ptrsIncome;
              this.transactionDetailsInfoTotalDist.ptrsPrincipal = ptrsPrincipal;
              this.transactionDetailsInfoTotalDist.ptrsDepositTaxCode = ptrsDepositTaxCode;

              this.transactionDetailsInfo.push({
                receivingAccount: {
                  accountNumber: toAccountInfo.accountNumber,
                  accountName: toAccountInfo.accountRegistration[0] ?? '',
                  accountType: toAccountInfo.regTypeShortName ?? ''
                },
                contributionType: this.itsInfo?.toAccountPropertiesById[toAccount]?.iraContributionType.description ?? 'N/A',
                distributionReason: this.itsInfo?.toAccountPropertiesById[toAccount]?.inputIraFields.distributionReason.description ?? 'N/A',
                ptrsIncome: ptrsIncome,
                ptrsPrincipal: ptrsPrincipal,
                ptrsDepositTaxCode: ptrsDepositTaxCode
              });

              // Set visibility flags
              if (accountPtrsData?.trustIncomeToPercent || accountPtrsData?.trustPrincipalToPercent || accountPtrsData?.trustDepositCode) {
                this.showToAccountPtrsFields = true;
                this.displayToAccPTRSFields = true;
              }

              this.has401kPtrsValuesSet = true;
              if (toAccountInfo?.isIraAccount) {
                this.iraToAccountExists = true;
              }
              this.fedTax = this.percentFormatPipe.transform(this.itsInfo?.toAccountPropertiesById[toAccount]?.inputIraFields.fedTaxPercent);
              this.stateTax = this.percentFormatPipe.transform(this.itsInfo?.toAccountPropertiesById[toAccount]?.inputIraFields.stateTaxPercent);
          })
          this.syncHeaderTaxRates();
        }
      });

      combineLatest([
        this.store.select(selectStateCode),
        this.store.select(selectNraIndicator)
      ]).pipe(takeUntil(this.destroy$)).subscribe(([stateCode, nraIndicator]) => {
        if (stateCode && !nraIndicator) {
          this.stateTaxLabel = `${this.labels.stateTax} (${stateCode})`;
        }
      });

      this.store.select(selectHasAccessInitiateMoneyMovement).pipe(takeUntil(this.destroy$)).subscribe(hasAccess => this.isInitRelease = hasAccess);
      this.store.select(selectIsStandingAuthViewPage).pipe(takeUntil(this.destroy$)).subscribe(value => this.isStandingAuthViewPage = value);

      this.store.select(selectTwePopupIndicator).pipe(takeUntil(this.destroy$)).subscribe(value => {
        this.openTwePopup = value;
        this.syncHeaderTaxRates();
      });
    }

    updateTaxValues(): void {
      if (this.currentPage === pageInContext.confirmation) {
        this.fedTax = this.fedTaxPercent ?? '';
      } else {
        this.fedTax = this.classifications.isNraAccount
          ? this.itsInfo?.multipleToJournalsList?.[0]?.iraFields?.fedTaxAmount ?? ''
          : !this.zeroFedAndStateTax ? (this.twe?.fedTaxRateUserEntered?.toString() ?? '') + '%' : '0%';
      }
      this.stateTax = !this.zeroFedAndStateTax ? this.twe?.stateTaxRateUserEntered?.toString() + '%' : '0%';
      this.syncHeaderTaxRates();
    }

    syncHeaderTaxRates(): void {
      if (this.currentPage === pageInContext.confirmation && this.openTwePopup) {
        const effectiveFedTax = this.zeroFedAndStateTax ? '0%' : (this.isOneTimeTotalDist ? this.fedTaxTotalDist : this.fedTax);
        const effectiveStateTax = this.zeroFedAndStateTax ? '0%' : (this.isOneTimeTotalDist ? this.stateTaxTotalDist : this.stateTax);
        this.store.dispatch(AccountInfoActions.updateHeaderTaxRates({
          federalTaxRate: effectiveFedTax,
          stateTaxRate: effectiveStateTax
        }));
      }
    }

    ngAfterViewInit() {
      setTimeout(() => {
        this.ToAccountTableWidth = this.setTableWidth('ToAccountTable');
        this.TransferTableWidth = this.setTableWidth('TransferTable');
      },10);
    }

  getFrequency(extraPrompts: ItExtraPrompts): string {
    // this indicates non-bundled flow
    if (extraPrompts.frequency) {
      return frequencyDict[extraPrompts.frequency!];
    }

    if (extraPrompts.useStandingAuth === 'bundled') {
      if (extraPrompts.useBundledStandingAuth === 'no') return frequencyDict['onetime'];
      if (extraPrompts.useBundledStandingAuth === 'recurring') return frequencyDict['recurring'];
    }
    return '';
  }

    onEditClicked(): void {
      this.store.dispatch(ReviewPageActions.clearAttentionMessage());
      AdobeHelpers.fireClick(AdobeConstants.LINKID + AdobeConstants._EDIT);
      this.store.dispatch(ReviewPageActions.editClicked());
     setTimeout(()=>{
      const titleEle = document.querySelector('#section-title');
      titleEle?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
     }, 500)
      let acknowledgement: Acknowledgement = {
        isAcknowledgementReviewed: false,
        acknowledgementConsentTime: ""
      }
      this.store.dispatch(ReviewPageActions.updateAcknowledgement({ acknowledgement }));
    }

    getToAccountPTRSfields(toAccount: any, toAccountPtrsFields: any) {
      let result = toAccountPtrsFields?.find((toAccountfields: any) => this.hyphenPipe.transform(toAccountfields.toAccount) === this.hyphenPipe.transform(toAccount.toAccountInfo?.accountNumber));
      if ((result?.trustIncomeToPercent || result?.trustPrincipalToPercent || result?.trustDepositCode) && this.transferType !== 'positions' && this.toAccountCashExists){
        this.showToAccountPtrsFields = true;
      }
      return {
        ptrsIncome: (result?.trustIncomeToPercent && currencyStringToNumber(toAccount?.journalCashAmount)) ? result?.trustIncomeToPercent : 'N/A',
        ptrsPrincipal: (result?.trustPrincipalToPercent && currencyStringToNumber(toAccount?.journalCashAmount)) ? result?.trustPrincipalToPercent : 'N/A',
        ptrsDepositTaxCode: (result?.trustDepositCode && currencyStringToNumber(toAccount?.journalCashAmount)) ? this.camelCasePipe.transform(result?.trustDepositCode) : 'N/A'
      };
    }

    getToAccountPTRSfieldsTotalDist(transactionDetails: any) {
      // If we're a 401k account and we've already set PTRS values, don't overwrite them
      if (this.is401kToAccount && this.has401kPtrsValuesSet) {
        return;
      }

      if ((transactionDetails?.toAccounts?.[0]?.trustIncomeToPercent || transactionDetails?.toAccounts?.[0]?.trustPrincipalToPercent || transactionDetails?.toAccounts?.[0]?.trustDepositCode) && this.transferType !== 'positions' && this.toAccountCashExists) {
        this.showToAccountPtrsFields = true;
      }
      this.transactionDetailsInfoTotalDist.ptrsIncome = (transactionDetails?.toAccounts?.[0]?.trustIncomeToPercent && transactionDetails?.cashAmounts?.[0]?.amount) ? transactionDetails?.toAccounts?.[0]?.trustIncomeToPercent : 'N/A';
      this.transactionDetailsInfoTotalDist.ptrsPrincipal = (transactionDetails?.toAccounts?.[0]?.trustPrincipalToPercent && transactionDetails?.cashAmounts?.[0]?.amount) ? transactionDetails?.toAccounts?.[0]?.trustPrincipalToPercent : 'N/A';
      this.transactionDetailsInfoTotalDist.ptrsDepositTaxCode = (transactionDetails?.toAccounts?.[0]?.trustDepositCode && transactionDetails?.cashAmounts?.[0]?.amount) ? this.camelCasePipe.transform(transactionDetails?.toAccounts?.[0]?.trustDepositCode) : 'N/A';
    }

  getProcessDate() {
    if (this.isOneTimeTotalDist){
      return this.processDate = this.itsInfo?.processDate;
    }
    if (!this.isReviewPage && this.confirmationPagePhase2) {
      let itAckListResponse = this.itsInfo.multipleAcknowledgeListById;
      if (itAckListResponse[this.toAccountInContextDetails.toAccountNumber]?.hasError) {
        return this.processDate = 'N/A';
      } else {
        return this.processDate = this.itsInfo.multipleToJournalsList[0]?.processDate ?? this.itsInfo?.processDate;
      }
    } else {      
      return this.processDate = this.itsInfo.multipleToJournalsList[0]?.processDate ?? this.itsInfo?.processDate;
    }
  }

    setTableWidth(tableID : string): string {
      if (this.isInrFromTable) return 'auto';
      const tableElement = document.getElementById(tableID);
      if (!tableElement) {
        return 'auto';
      }
      return (Array.from(tableElement.querySelectorAll('span.table-header'))).reduce((accumulator, currentValue) => {
        return accumulator + currentValue?.clientWidth;
      }, 0).toString() + 'px';
    }

     getTransactionTypeLabel(useStandingAuth : string): string {
      return useStandingAuth==='bundled'? `${this.labels.internalTransferJournal} - ${useStandingAuth}`: this.labels.internalTransferJournal
     }

    calculateSelectedPositionTotal(): string {
      var totalAmount = 0;
      this.positionData.forEach((emv: { [emv: string]: string; }) => {
        if (emv['Shares to move'] !== '') {
          totalAmount = totalAmount + parseFloat(emv['Estimated market value'].toString().replace(/[^\d.-]/g,''));
        }
      });
      return this.currencyPipe.transform(totalAmount) ?? '$0';
    }

    sumTotals(amounts: string[]): string {
      var total = 0;
      amounts.forEach(amount => {
        total = total + Number(amount.replace(/[^\d.-]/g,''));
      })
      return this.currencyPipe.transform(total) ?? '$0';
    }

    toAccountsPositionsTotal() {
      var total = 0;
      this.transferTotal.forEach(toAccount => {
        total = total + Number(toAccount.positionTotatValue.replace(/[^\d.-]/g,''));
      });
      return this.currencyPipe.transform(total) ?? '$0';
    }

    toAccountsCashTotal() {
      var total = 0;
      this.transferTotal.forEach(toAccount => {
        total = total + currencyStringToNumber(toAccount.cashTotalValue);
      });
      return this.currencyPipe.transform(total) ?? '$0';
    }

    toAccountsTotalToRecieve() {
      return this.currencyPipe.transform(Number(this.toAccountsPositionsTotal().replace(/[^\d.-]/g,'')) + Number(this.toAccountsCashTotal().replace(/[^\d.-]/g,'')));
    }

    getCBFormValue(costBasis: string) {
        if (costBasis === '') {
          return costBasis;
        }
        return positionConstants.costBasisMap.get(costBasis);
    }

    reorganizeToAccountOrder(unsortedArray: any){
      const correctOrderArray = Object.keys(this.itsInfo.toAccountInfo).map((acc) => (this.itsInfo.toAccountInfo[acc].accountNumber));
      const correctOrderMap = new Map(correctOrderArray.map((acc, index) => [acc, index]))
      unsortedArray.sort((a: any, b: any) => {
        const indexA = correctOrderMap.get(a.receivingAccount.accountNumber);
        const indexB = correctOrderMap.get(b.receivingAccount.accountNumber);
        return (indexA ?? -1) - (indexB ?? -1);
      })
    }

    get pageHeader(): string {
      return this.isStandingAuthViewPage ? 'Standing authorization details' : 'Transaction details';
    }

    get displayTrustComment() {
      return (this.classifications.isPtrs) && this.trustComment;
    }

    get receivingAccountInfo(): string[] {
      return [this.toAccountInContextDetails.toAccountNumber, this.toAccountInContextDetails.toAccountName, this.toAccountInContextDetails.toAccountType];
    }

    get isReviewPage(): boolean {
      return this.currentPage === pageInContext.review
    }

    get totalToReceiveVerbiage(): string {
      return 'Available upon completion of Internal Transfer';
    }

  isNotEmptyOrNull(param: any) {
    const params = param?.trim();
    if (params === null || params === undefined || params === 'undefined%' || params === '') {
      return false;
    }
    return true;
  }

  getStandingAuthDetails(extraPrompts: ItExtraPrompts) {
    if (extraPrompts.useStandingAuth === 'bundled') {
      if (extraPrompts.useBundledStandingAuth === 'yes') {
        return 'yes'
      }
      if (extraPrompts.useBundledStandingAuth === 'no') {
        return 'no'
      }
      return ''
    }
    return extraPrompts.useStandingAuth
  }

  formatReportsRequestedFields(form: TransactionForm) {
    if (form.transactionType && isInternalTransferForm(form)) {
      const fields = [
        { label: 'Tax forms through: ', value: form?.extraPrompts?.taxFormsDateInputControl },
        { label: 'Account statements through: ', value: this.dateFormatPipe.transform(form?.extraPrompts?.accountStatementsDateInputControl ?? '') },
        { label: 'Trade confirmations through: ', value: this.dateFormatPipe.transform(form?.extraPrompts?.tradeConfirmationsDateInputControl ?? '') },
      ];
      fields.forEach(field => {
        if (field.value) {
          this.reportsRequested.push(field.label, field.value);
        }
      });
    }
  }
}
